<script>
import Menu from '/src/components/header.vue';
import Rodape from '/src/components/rodape.vue';


export default {
    name: 'Sede',
    components: {
        Menu,
        Rodape
    }
}
</script>

<template>
    <Menu></Menu>
    <div class="sobre">
        <div class="content">
            <p class="titulo">SOBRE A NACIONAL INDÚSTRIA METALÚRGICA Ltda</p>
            <p class="text">A Nacional Indústria Metalúrgica Ltda é uma empresa dedicada à excelência na execução de
                serviços
                industriais,
                especializada em Usinagem, Caldeiraria, Montagem e Manutenção Industrial. Com uma equipe de
                profissionais
                altamente qualificados e comprometidos, buscamos sempre oferecer soluções técnicas que atendam
                rigorosamente
                às
                especificações de cada projeto, garantindo a satisfação total de nossos clientes.</p>

            <P class="subtitulo">Nossa Visão</P>
            <p class="text">Ser reconhecida como líder em soluções diferenciadas na execução de serviços industriais,
                com
                foco em Fabricação
                de Estruturas Metálicas, Usinagem de Precisão e Montagens Industriais. Almejamos ser uma referência no
                mercado,
                destacando-nos pela qualidade, inovação e compromisso com o cliente.</p>

            <p class="subtitulo">Nossa Missão</p>
            <p class="text">Desenvolver e fornecer soluções industriais inovadoras, garantindo a melhoria contínua dos
                processos por meio de
                boas práticas na Fabricação de Estruturas Metálicas, Usinagem de Precisão e Montagens Industriais.
                Buscamos
                crescer de forma sustentável, desenvolvendo nossos colaboradores e agregando valor para todos os
                envolvidos
                no
                negócio.</p>

            <p class="subtitulo">Nossos Valores</p>
            <ul class="lista">
                <li>Inovação: Incentivamos a criatividade e a busca constante por novos conhecimentos.</li>
                <li>Qualidade: Priorizamos a agilidade no atendimento e a excelência na execução dos serviços prestados.
                </li>
                <li>Ética: Valorizamos a integridade em todos os nossos relacionamentos e no cumprimento dos princípios
                    legais.</li>
                <li>Pessoas: Respeitamos e valorizamos nossos colaboradores, promovendo um ambiente de comprometimento e
                    realização.</li>
                <li>Segurança: A preservação da vida é nosso valor fundamental, assegurando ambientes de trabalho
                    seguros.
                </li>
                <li>Responsabilidade Socioambiental: Atuamos de forma sustentável, considerando os impactos
                    socioambientais
                    de
                    nossas atividades.</li>
            </ul>

            <p class="subtitulo">Nossas Atividades</p>
            <p class="text">A Nacional Indústria Metalúrgica Ltda oferece uma gama de serviços especializados,
                incluindo:
            </p>
            <ul class="lista">
                <li>Fabricação de Estruturas Metálicas</li>
                <li>Usinagem de Precisão e Recuperação de Peças</li>
                <li>Obras de Montagem e Manutenção Industrial</li>
            </ul>
            <p class="text2">Estamos comprometidos em entregar projetos dentro dos prazos, com segurança e qualidade,
                garantindo a
                confiança
                e a satisfação de nossos clientes.</p>

            <p class=subtitulo> Nossa Localização</p>
            <p class="text">Estamos localizados em R. Castelo, Nº 1214 - Bloco B - Jardim Limoeiro - Serra/ES </p>
            <P class="text">Com fácil
                acesso e prontos
                para atender às necessidades de nossos clientes em toda a região.</p>
        </div>
    </div>
    <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.sobre {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    min-height: 53.5vh;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    margin: 2rem 0rem;
}

.menu {
    position: relative;
    width: 100%;
    z-index: 1;
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0rem;
    color: #2e74c4;
    text-align: center;
}

.subtitulo {
    font-size: 1rem;
    font-weight: bold;
    margin: 1rem 0rem;
    color: #444;
}

.text {
    text-align: justify;
    font-size: 0.9rem;
    color: #444;
}
.text2 {
    text-align: justify;
    font-size: 1.3rem;
    color: #444;
    text-align: center;
    margin: 1rem 0rem;
}

.rodape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

ul {
    margin: 1rem 1rem;
    color: #444;
}

li {
    margin: 0.4rem 0rem;
    font-size: 0.9rem;
}
}
@media (min-width: 901px) {
.sobre {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    min-height: 53.5vh;
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 70%;
    margin: 2rem 0rem;
}

.menu {
    position: relative;
    width: 100%;
    z-index: 1;
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0rem;
    color: #2e74c4;
}

.subtitulo {
    font-size: 1rem;
    font-weight: bold;
    margin: 1rem 0rem;
    color: #444;
}

.text {
    text-align: justify;
    font-size: 0.9rem;
    color: #444;
}
.text2 {
    text-align: justify;
    font-size: 1.3rem;
    color: #444;
    text-align: center;
    margin: 1rem 0rem;
}

.rodape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

ul {
    margin: 1rem 1rem;
    color: #444;
}

li {
    margin: 0.4rem 0rem;
    font-size: 0.9rem;
}
}
</style>